import { getCurrentInstance } from 'vue'
import { useI18n as _useI18n } from 'vue-i18n'

export function useI18n() {
  const instance = getCurrentInstance()
  if (!instance) {
    throw new Error('useI18n must be called within setup.')
  }

  const {
    locale, t, te, d, n
  } = _useI18n()

  /**
   * Try to find a matching key, falling back to .__title__ if it exists
   */
  function resolveKeyWithTitle(teFn: (key: string) => boolean, key: string): string {
    // if key exists, use it
    if (teFn(key)) return key

    // otherwise check for key.__title__
    const titleKey = `${key}.__title__`
    if (teFn(titleKey)) return titleKey

    return key
  }

  function postTranslationUntranslatedFn(str: string, key: string | undefined): string {
    return key || str
  }

  function postTranslationDefaultFn(value: any, key: string | undefined): string {
    if (typeof value === 'object' && value && '__title__' in value) {
      return value.__title__
    }
    return typeof value === 'string' ? value : key || ''
  }

  /**
   * Wrap a translation function so that it automatically redirects
   * lookups to the __title__ field if needed
   */
  function wrapTWithPostTranslation(
    tFn: (key: string, values?: any) => any,
    teFn: (key: string) => boolean
  ) {
    return (key: string, values?: any) => {
      const resolvedKey = resolveKeyWithTitle(teFn, key)
      const result = tFn(resolvedKey, values)

      return /^\?untranslated/.test(window.location.search)
        ? postTranslationUntranslatedFn(result, key)
        : postTranslationDefaultFn(result, key)
    }
  }

  return {
    locale,
    t: wrapTWithPostTranslation(t, te),
    d: wrapTWithPostTranslation(d, te),
    te,
    n
  }
}
